import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { EmptyLayout } from '@wkda/funnel-components';
import { ResponsiveIframeScript } from './ResponsiveIframeScript';
export function PartnerFunnelLayout(props) {
  var additionalProps = {};
  if (typeof navigator != 'undefined' && !navigator.cookieEnabled) {
    additionalProps.customGDPRBanner = function () {
      return null;
    };
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ResponsiveIframeScript, null), /*#__PURE__*/React.createElement(EmptyLayout, _extends({}, props, additionalProps)));
}